module.exports = __webpack_public_path__ + "media/images/fleche blanc-0d5793b2c520408ac7b609f0b2bc5b24.svg";